import IdentifiableDto from 'modules/base/dto/IdentifiableDto';

export class ParositasAdatlapEditDto extends IdentifiableDto {
	constructor() {
		super();
		this.csomagNev = null;
		this.pairing = null;
		this.adatlapPath = null;
	}

	setup(props) {
		super.setup(props);
		this.csomagNev = props.csomagNev;
		this.pairing = props.pairing;
		this.adatlapPath = props.adatlapPath;
		return this;
	}
}

export default ParositasAdatlapEditDto;
